(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pli-newsletter-popup"]) return;
  try {
    
  class PliNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.component = this.querySelector('dialog-component');
      this.dialog = this.querySelector('dialog');
      this.success = Boolean(this.querySelector('[data-pli-newsletter-success]'));
      this.hasError = Boolean(this.querySelector('[data-pli-newsletter-error]'));
      this.handleClose = this.handleClose.bind(this);
      this.handleSectionSelect = this.handleSectionSelect.bind(this);
      customElements.whenDefined('dialog-component').then(() => this.initialize());
    }
    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      this.component?.removeEventListener('dialog:close', this.handleClose);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
    }
    initialize() {
      if (!this.component || !this.dialog) return;
      this.component.addEventListener('dialog:close', this.handleClose);
      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        return;
      }
      if (this.success) {
        this.remember('subscribed', Number(this.dataset.successDays));
        this.open();
        return;
      }
      if (this.hasError) {
        this.open();
        return;
      }
      if (this.isSuppressed()) return;
      this.openTimer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 0);
    }
    open() {
      if (this.dialog?.open) return;
      if (document.hidden) {
        document.addEventListener('visibilitychange', () => this.open(), { once: true });
        return;
      }
      this.component?.showDialog();
      window.setTimeout(() => {
        this.querySelector('[data-pli-newsletter-copy], .pli-newsletter-popup__input')?.focus();
      }, 80);
    }
    handleClose() {
      if (this.dataset.designMode === 'true') return;
      const days = this.success ? Number(this.dataset.successDays) : Number(this.dataset.closeDays);
      this.remember(this.success ? 'subscribed' : 'dismissed', days);
    }
    handleSectionSelect(event) {
      if (event.detail?.sectionId === this.dataset.sectionId) this.open();
    }
    isSuppressed() {
      try {
        const state = JSON.parse(localStorage.getItem(this.dataset.storageKey));
        return Number(state?.until) > Date.now();
      } catch {
        return false;
      }
    }
    remember(status, days) {
      try {
        localStorage.setItem(
          this.dataset.storageKey,
          JSON.stringify({ status, until: Date.now() + days * 86400000 })
        );
      } catch {}
    }
  }
  if (!customElements.get('pli-newsletter-popup')) {
    customElements.define('pli-newsletter-popup', PliNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
